<template lang="pug">
#app
  header.app-header
    app-nav
  .router-container
    router-view(:key="$route.fullPath")
  app-footer
  modal-view
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

import api from '@/api'
import AppNav from './components/AppNav'
import AppFooter from './components/AppFooter'
import LoginView from './views/LoginView'

export default {
  name: 'app',
  components: {
    AppNav,
    AppFooter,
    LoginView
  },
  computed: mapGetters({
    loggedIn: 'isLoggedIn'
  }),
  mounted () {
    if (this.loggedIn) {
      this.syncUserProfile()
    }
  },
  methods: {
    ...mapActions(['setUser']),
    syncUserProfile () {
      api.get('/customers/profile/').then(response => {
        this.setUser(response.data)
      })
    }
  }
}
</script>

<style lang="scss">
@import url(https://maxcdn.icons8.com/fonts/line-awesome/1.1/css/line-awesome-font-awesome.min.css);
@import "./styles/style.scss";
@import "~bootstrap-vue/dist/bootstrap-vue.css";
@import "~slick-carousel/slick/slick.css";
@import "~slick-carousel/slick/slick-theme.css";
@import  "~vue-multiselect/dist/vue-multiselect.min.css";
</style>



// WEBPACK FOOTER //
// src/App.vue